import React, { FC } from 'react'

import { LineLimitTxt } from 'src/components/atoms'
import { CompassRoleTxt, DeletingLabel, ProjectStatusTxt } from 'src/components/molecules'

import { AssignedProjectEntity } from 'src/types'

type Props = {
  project: AssignedProjectEntity
  className?: string
}

export const AssignProjectListItem: FC<Props> = ({ project, className }) => {
  return (
    <div className={className}>
      <div className="tw-p-s-1">
        <div className="tw-h-s4 tw-flex tw-items-center tw-gap-s0">
          <LineLimitTxt
            maxLineLimit={2}
            text={project.name}
            className={`tw-w-full tw-font-bold tw-shrink ${
              project.isDeleting ? 'tw-opacity-30' : 'tw-opacity-100'
            }`}
          />
          <div className="tw-w-s6 tw-font-bold tw-shrink-0">
            {project.isDeleting ? <DeletingLabel /> : <ProjectStatusTxt status={project.status} />}
          </div>
          <CompassRoleTxt
            displayName={project.compassRole.displayName}
            className={`tw-text-standardText-secondary tw-w-[9rem] tw-max-w-[7.9rem] tw-text-left tw-shrink-0 ${
              project.isDeleting ? 'tw-opacity-30' : 'tw-opacity-100'
            }`}
          />
        </div>
      </div>
    </div>
  )
}
